import PropTypes from 'prop-types'

import { Button, Tooltip } from '@material-ui/core'

import { Filter } from 'react-feather'

const FilterButton = ({ setDrawerOpen }) => {
  return (
    <Tooltip title="Filtros">
      <Button
        onClick={() => setDrawerOpen(true)}
        startIcon={<Filter width="18" />}
        variant="outlined"
      >
        Filtros
      </Button>
    </Tooltip>
  )
}

FilterButton.prototype = {
  setDrawerOpen: PropTypes.func,
}

FilterButton.defaultProps = {
  setDrawerOpen: () => {},
}

export default FilterButton
